import { ICrossCamera } from "@/types/map";
import LaneQueueLength from "../../LaneQueueLength/arcgis/LaneQueueLength";
import { checkPoints } from "../../MapCenterCheck/arcgis/CheckPoints";
import SignalPhaseController from "../../SignalPhase/SignalPhaseController";

//declare let FlareCameraPositionLayer: any;
//import FlareCameraPositionLayer from './Render/FlareCameraPositionLayer_v4';
export class CameraPosition {
  private static intances: Map<string, CameraPosition>;
  private view!: __esri.SceneView;
  private stopHandler!: IHandle | undefined;
  private watchHandl: __esri.WatchHandle | undefined = undefined;
  /** 通知页面查询新相位的接口 */
  public requestNextSignalPhase!: (crossId: string) => void;
  public phaseChanged!: (crossId: string, phase: string) => void;

  public crossInfoPanelInfos?: Array<{
    id: string;
    position: number[];
    positionCoor: number[];
    videoUrl: string;
    lineDir?: string;
    devicePosition?: number[];
    devicePositionCoor?: number[];
  }>;
  private crossId!: string;
  private laneQueueLength: LaneQueueLength;
  private signalPhaseController: SignalPhaseController;

  private constructor(view: __esri.SceneView) {
    this.view = view;
    this.laneQueueLength = LaneQueueLength.getInstance(view);
    this.signalPhaseController = SignalPhaseController.getInstance(this.view);
  }

  public static getInstance(view: any) {
    let id = view.container.id;
    if (!CameraPosition.intances) {
      CameraPosition.intances = new Map();
    }
    let intance = CameraPosition.intances.get(id);
    if (!intance) {
      intance = new CameraPosition(view);
      CameraPosition.intances.set(id, intance);
    }
    return intance;
  }

  public async clearCrossCamera() {
    if (this.crossId) {
      if (this.crossInfoPanelInfos) {
        this.crossInfoPanelInfos.splice(0, this.crossInfoPanelInfos.length);
      }
      if (this.laneQueueLength) {
        this.laneQueueLength.hideQueueLength(this.crossId);
      }
      if (this.signalPhaseController) {
        this.signalPhaseController.stopSignalPhase(this.crossId);
      }
      if (this.stopHandler) {
        this.stopHandler.remove();
        this.stopHandler = undefined;
      }
      if (this.watchHandl) {
        this.watchHandl.remove();
        this.watchHandl = undefined;
      }
    }
  }
  public async setCrossCamera(params: ICrossCamera) {
    this.signalPhaseController.requestNextSignalPhase = this.requestNextSignalPhase;
    this.signalPhaseController.phaseChanged = this.phaseChanged;
    this.clearCrossCamera();

    const { position, heading, tilt, duration, crossId, type } = params;
    let showCenter: boolean = params.showCenter !== false;
    let showQueue: boolean = params.showQueue !== false;
    let showPhase: boolean = params.showPhase !== false;
    let showPanel: boolean = params.showPanel !== false;
    let banMove: boolean = params.banMove !== false;
    if (crossId) {
      this.crossId = crossId;
      //如果存在路口id,读取配置
      let checkPoint = checkPoints.find((cross: any) => cross.id === crossId);
      if (checkPoint) {
        let CrossCam = checkPoint.camera
          ? checkPoint.camera
          : checkPoint.position
          ? {
              position: [checkPoint?.position[0], checkPoint?.position[1], 460],
              heading: 0,
              tilt: 0,
            }
          : undefined;
        if (CrossCam && showCenter) {
          await this.view.goTo(CrossCam, CrossCam);
        }
      }

      //显示相位
      if (showPhase) {
        this.signalPhaseController.setSignalPhase({
          showCenter: false,
          crossId,
        } as any);
      }
      //显示排队长度
      if (showQueue) {
        this.laneQueueLength.showQueueLength(crossId);
      }
      //显示视频面板
      if (showPanel) {
        if (
          checkPoint?.panelPositions &&
          checkPoint?.panelPositions.length > 0
        ) {
          checkPoint?.panelPositions.forEach(
            (panelInfo: {
              id: string;
              position: number[];
              videoUrl: string;
              lineDir?: string;
              devicePosition?: number[];
            }) => {
              const screenPoint = this.view.toScreen({
                type: "point",
                x: panelInfo.position[0],
                y: panelInfo.position[1],
                spatialReference: { wkid: 4326 },
              } as any);
              if (panelInfo.devicePosition) {
                const devicePoint = this.view.toScreen({
                  type: "point",
                  x: panelInfo.devicePosition[0],
                  y: panelInfo.devicePosition[1],
                  spatialReference: { wkid: 4326 },
                } as any);
                this.crossInfoPanelInfos?.push({
                  id: panelInfo.id,
                  position: [screenPoint.x, screenPoint.y],
                  positionCoor: panelInfo.position,
                  videoUrl: panelInfo.videoUrl,
                  lineDir: panelInfo.lineDir,
                  devicePosition: [devicePoint.x, devicePoint.y],
                  devicePositionCoor: panelInfo.devicePosition,
                });
              } else {
                this.crossInfoPanelInfos?.push({
                  id: panelInfo.id,
                  position: [screenPoint.x, screenPoint.y],
                  positionCoor: panelInfo.position,
                  videoUrl: panelInfo.videoUrl,
                });
              }
            }
          );
        }
        if (!banMove) {
          this.watchHandl = this.view.watch("interacting", () => {
            // if (this.view.stationary)
            this.changePanelPosition();
          });
        }
      }
      //地图禁止移动
      if (banMove) {
        if (!this.stopHandler) {
          this.stopHandler = this.view.on(
            "drag,mouse-wheel,double-click,key-down",
            (event: any) => {
              event.stopPropagation();
            }
          );
        }
      }
    } else {
      this.view.goTo({ position, heading, tilt }, { duration });
    }
  }

  // 面板跟随地图一起移动
  private changePanelPosition() {
    this.crossInfoPanelInfos?.forEach((panel) => {
      // 移动面板位置
      const screenPoint = this.view.toScreen({
        type: "point",
        x: panel.positionCoor[0],
        y: panel.positionCoor[1],
        spatialReference: { wkid: 4326 },
      } as any);
      panel.position = [screenPoint.x, screenPoint.y];
      // // 移动连线点位置
      // if (panel.devicePositionCoor) {
      //   const deviceScreenPoint = this.view.toScreen({
      //     type: "point",
      //     x: panel.devicePositionCoor[0],
      //     y: panel.devicePositionCoor[1],
      //     spatialReference: { wkid: 4326 },
      //   } as any);
      //   panel.devicePosition = [deviceScreenPoint.x, deviceScreenPoint.y];
      // }
    });
  }
}
